import { render, staticRenderFns } from "./TabelaDia.vue?vue&type=template&id=5206e0a7"
import script from "./TabelaDia.vue?vue&type=script&lang=js"
export * from "./TabelaDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports